import { Sparkles } from 'lucide-react';

// Restyling Step 0 — Deliverable 4
// Schermata di benvenuto Assistente mAIstro. Il ChatWidget flottante
// (montato globalmente in Layout) resta invariato: qui nessun input chat,
// nessun microfono — solo onboarding verso WhatsApp.
const WHATSAPP_URL = 'https://wa.me/14155238886';

export default function Assistente() {
  return (
    <div style={{
      flex: 1, minHeight: '100%', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '32px 20px',
    }}>
      <div style={{ width: '100%', maxWidth: 480, textAlign: 'center' }}>

        {/* Icona */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <Sparkles size={48} color="var(--zone-violet)" strokeWidth={1.6} />
        </div>

        {/* Titolo */}
        <h1 className="font-display" style={{ fontSize: 24, fontWeight: 700, color: 'var(--ink)', margin: '0 0 12px' }}>
          Il tuo Assistente mAIstro
        </h1>

        {/* Sottotitolo */}
        <p style={{ fontSize: 14, color: 'var(--ds-muted)', lineHeight: 1.6, margin: '0 auto', maxWidth: 420 }}>
          Presto potrai chiedermi tutto: cantieri, fatture, scadenze — con la voce
          o per iscritto, direttamente qui.
        </p>

        {/* Separatore */}
        <div style={{ height: 1, background: 'var(--ds-border)', margin: '28px auto', maxWidth: 320 }} />

        {/* Label */}
        <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--ds-text)', marginBottom: 16 }}>
          Nel frattempo, usami su WhatsApp 👇
        </div>

        {/* CTA WhatsApp */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            padding: '12px 28px', borderRadius: 'var(--radius-base)',
            background: 'var(--brand-gradient)', color: 'white', fontSize: 14,
            fontWeight: 600, textDecoration: 'none',
            boxShadow: '0 4px 16px rgba(46,160,132,0.22)',
          }}
        >
          Apri WhatsApp
        </a>

        {/* Nota */}
        <div style={{ fontSize: 12, color: 'var(--ds-muted)', marginTop: 16 }}>
          L'assistente in-app arriverà presto.
        </div>
      </div>
    </div>
  );
}
